import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const DisplayData = () => {
  const location = useLocation();
  const { formData } = location.state || {};

  return (
    <div style={{ padding: '20px' }}>
      <h2>Submitted Data</h2>
      {formData ? (
        <table border="1" cellPadding="10" style={{ width: '100%', textAlign: 'left' }}>
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>First Name</td>
              <td>{formData.firstName}</td>
            </tr>
            <tr>
              <td>Last Name</td>
              <td>{formData.lastName}</td>
            </tr>
            <tr>
              <td>Address</td>
              <td>{formData.address}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{formData.city}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{formData.state}</td>
            </tr>
            <tr>
              <td>ZIP Code</td>
              <td>{formData.zipCode}</td>
            </tr>
            <tr>
              <td>Year Built</td>
              <td>{formData.yearBuilt}</td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>{formData.phone}</td>
            </tr>
            <tr>
              <td>Cell</td>
              <td>{formData.cell}</td>
            </tr>
            <tr>
              <td>Work</td>
              <td>{formData.work}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <p>No form data submitted.</p>
      )}
      <Link to="/">Go Back</Link>
    </div>
  );
};

export default DisplayData;
